import script from "./InfiniteSliding.vue?vue&type=script&setup=true&lang=js"
export * from "./InfiniteSliding.vue?vue&type=script&setup=true&lang=js"

import "./InfiniteSliding.vue?vue&type=style&index=0&id=830d4762&lang=css"

const __exports__ = script;

export default __exports__